import { Outlet } from "react-router-dom";
import AnnouncementBar from "@/components/AnnouncementBar";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileBottomBar from "@/components/MobileBottomBar";

export default function Layout() {
  return (
    <div className="App min-h-screen bg-[#fdfdfd]">
      <AnnouncementBar />
      <Header />
      {/* padding-top = announcement bar + header height */}
      <main className="pt-[calc(var(--announce-h,34px)+92px)]">
        <Outlet />
      </main>
      <Footer />
      <MobileBottomBar />
      {/* spacer so content isn't hidden behind mobile bottom bar */}
      <div className="h-[56px] lg:hidden" aria-hidden />
    </div>
  );
}
